import { Injectable } from "@angular/core";
import { ICredentials, ILoggedInUser } from "@gloria-public/login/domain/interfaces/login.interface";
import { Observable } from "rxjs";
import { ApiService } from "./api.service";
@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private api: ApiService) {}

  /**
   * Authenticates a user and returns login tokens or 2FA/verification flow data
   * @param credentials user login credentials
   * @param code2FA code used for the 2FA
   * @return login output
   */
  public login(credentials: ICredentials, code2FA?: string): Observable<ILoggedInUser> {
    const headerParams = {
      ...(this.api.appendGuestHeader() ?? {}),
      ...(code2FA ? { Authorization: `2FA ${code2FA}` } : {}),
    };

    return this.api.post(
      "user/auth",
      credentials,
      Object.keys(headerParams).length ? headerParams : undefined,
      false
    ) as Observable<ILoggedInUser>;
  }

  /**
   * Logs out the current authenticated user
   * @returns Success or error
   */
  public logout(): Observable<void> {
    return this.api.post("user/logout", {}) as Observable<void>;
  }
}
